<div *ngIf="errorMessage !== null">{{errorMessage}}</div>
